<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let notes: string;

</script>

<span class="fizz-inline-4">
  <Icon type="Notes" width={16} height={20} />
</span>
<span class="fizz-inline-4">
  {notes}
</span>
